import { TableColumn } from '@/classes'

const Columns = [
  new TableColumn('Name', 'name', true, 'asc', 'left'),
  new TableColumn('ABN', 'abn', true, 'asc', 'left'),
  new TableColumn('Address', 'address', true, 'asc', 'left'),
  new TableColumn('Suburb', 'suburb', true, 'asc', 'left'),
  new TableColumn('State', 'state', true, 'asc', 'centered'),
  new TableColumn('Country', 'country', true, 'asc', 'left'),
  new TableColumn('Expiry Date', 'expiryDate', true, 'asc', 'left'),
  new TableColumn('Login ID', 'loginId', true, 'asc', 'left'),
  new TableColumn('Is Active', 'isActive', true, 'asc', 'left')
]

export { Columns }
